import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqItems: FAQItem[] = [{
    question: '¿Necesito saber de ciencia o medicina?',
    answer: "No. Todo está explicado en lenguaje claro. Si entiendes 'modo estrés vs modo calma', entiendes el 80% del protocolo."
  }, {
    question: '¿Cuánto tiempo toma al día?',
    answer: '7 minutos antes de dormir (Reset) + 2 minutos de registro en el workbook. 9 minutos diarios. Eso es todo.'
  }, {
    question: '¿Funciona si tengo insomnio severo?',
    answer: 'Este protocolo es educativo. Si tienes insomnio crónico diagnosticado, consulta primero a tu médico. Este sistema puede complementar, no reemplazar, un tratamiento profesional.'
  }, {
    question: '¿Necesito apps, wearables o equipos especiales?',
    answer: 'No. Solo papel, lápiz y consistencia. El tracking es manual y toma 2 minutos.'
  }, {
    question: '¿Está en español neutro?',
    answer: 'Sí. Español neutro. Funciona para cualquier hispanohablante en USA o México.'
  }, {
    question: '¿Qué pasa si no mejoro en 14 noches?',
    answer: 'La guía incluye un árbol de decisión completo. Y tienes garantía de 30 días para pedir reembolso total.'
  }, {
    question: '¿Cuándo recibo los PDFs?',
    answer: 'Inmediatamente después del pago. Acceso instantáneo. Descarga directa. Funciona en teléfono, tablet o impreso.'
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full bg-navy py-16 md:py-24 px-4" data-id="element-15">
      <div className="max-w-2xl mx-auto" data-id="element-16">
        <p className="text-cyan text-sm uppercase tracking-widest text-center mb-4" data-id="element-17">
          PREGUNTAS FRECUENTES
        </p>

        <h2 className="text-2xl md:text-4xl font-bold text-white text-center mb-12" data-id="element-18">
          Preguntas frecuentes:
        </h2>

        <div className="space-y-3" data-id="element-19">
          {faqItems.map((item, index) => <div key={index} className="bg-navy-light rounded-xl border border-white/10 overflow-hidden" data-id="element-20">
              <button onClick={() => toggleFAQ(index)} className="w-full p-4 flex items-center justify-between text-left hover:bg-white/5 transition-colors" aria-expanded={openIndex === index} data-id="element-21">
                <span className="text-white font-semibold pr-4" data-id="element-22">
                  {item.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-cyan flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-23" />
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`} data-id="element-24">
                <p className="px-4 pb-4 text-gray-300" data-id="element-25">{item.answer}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}